import React from "react";

const INPUT_CLASS = "rounded-md border border-gray-300 bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400";

export default function PatientPersonalDetails({ saving, hasChanges, onSave, onCancel, form, onChangeField }) {
  return (
    <section className="rounded-xl border border-black/10 bg-white/80 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-base font-semibold text-gray-900">Persönliche Angaben</h2>
        {hasChanges && (
          <div className="flex items-center gap-2">
            <button onClick={onSave} disabled={saving} className="rounded-md bg-[#76B3FF] px-3 py-1.5 text-white hover:bg-[#5d9ef7] disabled:opacity-60">
              {saving ? "Speichert…" : "Speichern"}
            </button>
            <button onClick={onCancel} disabled={saving} className="rounded-md border border-gray-300 px-3 py-1.5 text-gray-700 hover:bg-white/70">
              Änderungen verwerfen
            </button>
          </div>
        )}
      </div>
      <fieldset disabled={saving} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 flex items-center justify-center rounded-full border-2 border-black/70">
            <svg viewBox="0 0 24 24" className="h-9 w-9">
              <circle cx="12" cy="8" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
              <path d="M4 19c1.8-3 4.6-4.5 8-4.5S18.2 16 20 19" fill="none" stroke="currentColor" strokeWidth="1.5" />
            </svg>
          </div>
        </div>
        {[
          ["forename", "Vorname"], ["language", "Sprache"], ["voice", "Stimme"],
          ["surname", "Nachname"], ["birthdate", "Geburtstag"], ["betreuer", "Zuständiger Betreuer"],
        ].map(([key, label]) => (
          <label key={key} className="grid grid-cols-1 gap-2 text-sm text-gray-700">
            {label}
            {key === "language" || key === "voice" ? (
              <select value={form[key]} onChange={(e) => onChangeField(key, e.target.value)} className={INPUT_CLASS}>
                {(key === "language" ? [["de", "Deutsch"]] : [["female", "Weiblich"], ["male", "Männlich"]]).map(([value, text]) => (
                  <option key={value} value={value}>{text}</option>
                ))}
              </select>
            ) : (
              <input type={key === "birthdate" ? "date" : "text"}
                max={key === "birthdate" ? new Date().toISOString().slice(0, 10) : undefined} value={form[key]}
                onChange={(e) => onChangeField(key, e.target.value)} className={INPUT_CLASS} />
            )}
          </label>
        ))}
      </fieldset>
    </section>
  );
}
